import type { SVGProps } from "react";
const SvgArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M795.707 85.2929C796.098 85.6834 796.098 86.3166 795.707 86.7071L791.414 91H803C803.552 91 804 91.4477 804 92C804 92.5523 803.552 93 803 93H791.414L795.707 97.2929C796.098 97.6834 796.098 98.3166 795.707 98.7071C795.317 99.0976 794.683 99.0976 794.293 98.7071L788.293 92.7071C787.902 92.3166 787.902 91.6834 788.293 91.2929L794.293 85.2929C794.683 84.9024 795.317 84.9024 795.707 85.2929Z"
      fill="currentColor"
      transform="translate(-784 -80)"
    />
  </svg>
);
export default SvgArrowLeft;
